import { useCallback } from 'react';
import type { SelectedRoomTypeValue } from '~/components/BookingFlow/Information/RoomAssignments';
import { PackageInformationRequest } from '~/types/api';

export type RoomAssignmentValue = {
  order_session_room_type_id: number;
  participant_index: number | null;
};

type ParticipantValue = PackageInformationRequest['participants'][0];

export default function useRoomAssignments() {
  const initialRoomAssignments = useCallback((
    selectedRoomTypes?: SelectedRoomTypeValue[],
    participants?: ParticipantValue[],
  ): RoomAssignmentValue[] => {
    const availableRooms: RoomAssignmentValue[] = [];
    const participantsToPlace = [...participants ?? []];

    selectedRoomTypes?.forEach((selectedRoomType) => {
      for (let i = 0; i < selectedRoomType.pax; i += 1) {
        const participant = participantsToPlace.shift();

        availableRooms.push({
          order_session_room_type_id: selectedRoomType.order_session_room_type_id,
          participant_index: participant?.index ?? null,
        });
      }
    });

    return availableRooms;
  }, []);

  return {
    initialRoomAssignments,
  };
}
